import { motion } from "framer-motion";
import { whyUs } from "@/data/homeData";

export function WhyChooseUs() {
  return (
    <section className="py-20 bg-[#F5F0EB]" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl text-[#004333]">Pourquoi choisir Happyhouse conciergerie</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
          {whyUs.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
                className="text-center p-8 bg-[#FFFDF9] rounded-xl border border-[#E0D6CA] shadow-[0_2px_8px_rgba(44,30,20,0.05)] hover:shadow-[0_8px_24px_rgba(44,30,20,0.1)] hover:-translate-y-1 transition-all duration-400"
              >
                <div className="w-14 h-14 bg-[#C9922A]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Icon className="w-7 h-7 text-[#C9922A]" strokeWidth={1.5} />
                </div>
                <h3 className="text-lg text-[#004333] mb-4 font-semibold">{item.title}</h3>
                <p className="text-[#8B7D6B] text-sm leading-relaxed">{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
